import styled from "@emotion/styled";
import { useState } from "react";

import { useHovered } from "~/hooks/useHovered";

import { NftPageFeedCardImageBase } from "./styled";

export type Props = {
  image: string;
  rearImage: string;
};

const NftCardImageWithFlip = ({ image, rearImage }: Props): JSX.Element => {
  const [clicked, setClicked] = useState(false);
  const [touched, setTouched] = useState(false);
  const { hovered, setHovered, onMouseLeave, ...hoverProps } =
    useHovered<HTMLDivElement>({
      useRefToScrollDetection: true
    });

  const handleClickWrapper = (): void => {
    if (touched && hovered && !clicked) {
      setHovered(hovered);
    } else {
      setHovered(actualHovered => !actualHovered);
    }

    setClicked(actualClicked => !actualClicked);
  };

  const handleTouchStart = (): void => {
    setTouched(true);
  };

  const handleMouseLeave = (): void => {
    onMouseLeave();
    setTouched(false);
    setClicked(false);
  };

  return (
    <FlipWrapper
      {...hoverProps}
      onClick={handleClickWrapper}
      onTouchStart={handleTouchStart}
      onMouseLeave={handleMouseLeave}
    >
      <FlipInnerWrapper flipped={hovered}>
        <FlipImageWrapper>
          <NftPageFeedCardImageBase srcSet={image} />
        </FlipImageWrapper>
        <FlipRearImageWrapper>
          <NftPageFeedCardImageBase srcSet={rearImage} />
        </FlipRearImageWrapper>
      </FlipInnerWrapper>
    </FlipWrapper>
  );
};

export default NftCardImageWithFlip;

const FlipWrapper = styled.div`
  outline: none;
  perspective: 1000px;
`;

const FlipInnerWrapper = styled.div<{ flipped: boolean }>`
  height: 100%;
  position: relative;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.8s;
  width: 100%;
  ${({ flipped }) => flipped && `transform: rotateY(180deg);`}
`;

const FlipImageWrapper = styled.div`
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
`;

const FlipRearImageWrapper = styled(FlipImageWrapper)`
  transform: rotateY(180deg);
`;
